<script>

  export default {
    props: {
      name: {
        type: String,
        required: true,
      },
      value:{
        type: Object,
        required: true
      },
      nameClasses:{
        type: String,
        default: ''
      },
      valueClasses:{
        type: String,
        default: ''
      },
    },
  }
</script>

<template>
  <li v-if="value && name" class="tw-flex tw-flex-col md:tw-flex-row tw-pb-2 md:tw-pb-3">
    <span class="tw-text-black/75 tw-w-full md:tw-w-1/4" :class="nameClasses">{{name}}</span>
    <span class="tw-font-semibold md:tw-text-right tw-w-full md:tw-w-3/4 tw-pl-12 md:tw-pl-0 tw-flex md:tw-justify-end tw-justify-start">
      <BaseStatusChip
        class="tw-border tw-border-black tw-border-opacity-15"
        :class="valueClasses"
        :status="value"/>
    </span>
  </li>
</template>
